import clsx from 'clsx';
import React from 'react';
import Button from '../Button';
import WarningIcon from '../../assets/icons/warning-icon.svg?react';
import { LoginResponseData } from '@EHSNavigator/backend';
import { useLocalStorage } from '@uidotdev/usehooks';

interface NoDepartmentProps {
  otherClasses?: string;
}

const NoDepartment: React.FC<NoDepartmentProps> = ({ otherClasses }) => {
  const noDepartmentClasses = clsx(
    otherClasses,
    'bg-light-neutral-tones-text/30 absolute flex flex-col left-0 top-0 h-screen w-full items-center justify-center backdrop-blur-xs md:px-0 px-4',
  );

  const [user] = useLocalStorage<LoginResponseData>('userInfo');

  return ['Admin', 'Owner'].includes(user?.user?.role?.name) ? (
    <div className={noDepartmentClasses} data-testid="no-department">
      <div className="flex flex-col items-center text-center">
        <WarningIcon className="[&>g>path]:fill-brand-byzantine h-12 w-12 md:h-85 md:w-85" />

        <h3 className="text-brand-byzantine">No departments found</h3>
        <p className="text-neutral-tones-text font-inter-variable mt-4 text-base">
          To move forward please create a department first.
        </p>
        <Button href="/departments" size="small" otherClasses="mt-4">
          Create Department
        </Button>
      </div>
    </div>
  ) : (
    <div className={noDepartmentClasses} data-testid="no-department">
      <div className="flex flex-col items-center text-center">
        <WarningIcon className="[&>g>path]:fill-brand-byzantine h-12 w-12 md:h-85 md:w-85" />

        <h3 className="text-brand-byzantine">No departments found</h3>
        <p className="text-neutral-tones-text font-inter-variable mt-4 text-base">
          Please reach out to your administrator to set up a department.
        </p>
      </div>
    </div>
  );
};

export default NoDepartment;
